import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
import parserFilters from '@/utils/parserFilters'
import parserSlug from '@/utils/parserSlug'

Vue.use(Vuex)

const state = {
  quotations: [],
  quotation: {
    status: 1,
    is_tax: true,
    general_delivery_time_flag: false,
    type_utility: false,
    type_utility_calculation: false,
    type_fletes: false,
    utility: 0,
    created_at: new Date(),
    updated_at: new Date(),
    date_aux: new Date(),
    flete: 0,
    pu: 0,
    currency_id: 2,
    exchange_rate: 1,
    discount: 0,
    comments: ' ',
    details: [],
    delivery_unit: 'days',
    subtotal: 0,
    total: 0
  },
  pagination: {
    currentPage: 1,
    perPage: 5,
    totalQuotations: 0,
    totalPages: 0
  },
  quotationsCatalog: {
    suppliers: [],
    customers: [],
    currencies: [],
    users: [],
    products: [],
    lossReasons: []
  },
  quotationSuppliers: [],
  filterParams: '',
  isModalVisible: false,
  isModalPropVisible: false,
  isModalLossVisible: false,
  isModalActionPropVisible: false,
  isModalSetOrderVisible: false,
  quotationProductsAttachments: [],
  isModalSupplierQuotationsVisible: false,
  isModalLossReasonVisible: false,
  customer: {},
  users: []
}

const mutations = {
  INIT_QUOTATION_DETAIL (state, payload) {
    state.quotation = payload
  },
  SET_QUOTATIONS (state, payload) {
    state.quotations = payload.data

    state.pagination = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      totalQuotations: payload.total,
      totalPages: payload.last_page
    }
  },
  ADD_QUOTATION (state, payload) {
    state.quotations.unshift(payload)
  },
  UPDATE_QUOTATION (state, payload) {
    state.quotation = payload
  },
  UPDATE_QUOTATIONS_ACTION (state, payload) {
    const idx = state.quotations.findIndex(u => u.id === payload.id)
    if (idx >= 0) {
      Vue.set(state.quotations, idx, payload)
    }
  },
  DELETE_QUOTATION (state, payload) {
    const idx = state.quotations.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.quotations, idx)
    }
  },
  DELETE_QUOTATIONS (state, payload) {
    for (let id of payload.ids) {
      const idx = state.quotations.findIndex(u => u.id === id)

      if (idx >= 0) {
        Vue.delete(state.quotations, idx)
      }
    }
  },
  ADD_QUOTATION_DETAIL (state, payload) {
    state.quotation.details.push(payload)
  },
  UPDATE_QUOTATION_DETAIL (state, { payload, idx }) {
    if (idx >= 0) {
      Vue.set(state.quotation.details, idx, payload)
    }
  },
  DELETE_QUOTATION_DETAIL (state, idx) {
    if (idx >= 0) {
      Vue.delete(state.quotation.details, idx)
    }
  },
  DELETE_QUOTATION_DETAILS (state, payload) {
    let idxs = payload.values.sort((a, b) => b - a)
    for (let idx of idxs) {
      console.log(idx)
      if (idx >= 0) {
        Vue.delete(state.quotation.details, idx)
      }
    }
  },
  SET_QUOTATION (state, payload) {
    state.quotation = {
      id: payload.data.id,
      folio: payload.data.folio,
      created_at: payload.data.created_at,
      updated_at: payload.data.updated_at,
      is_tax: payload.data.is_tax,
      type_utility: payload.data.type_utility,
      type_fletes: payload.data.type_fletes,
      delivery_time: payload.data.delivery_time,
      general_delivery_time_flag: payload.data.general_delivery_time_flag,
      delivery_address: payload.data.delivery_address,
      payment_conditions: payload.data.payment_conditions,
      flete: parseFloat(payload.data.flete),
      discount: parseFloat(payload.data.discount),
      total: parseFloat(payload.data.total),
      subtotal: payload.data.details.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toFixed(2),
      tax_rate: parseInt(16),
      sales_tax: parseFloat(payload.data.sales_tax),
      utility: parseFloat(payload.data.utility),
      comments: payload.data.comments,
      exchange_rate: parseFloat(payload.data.exchange_rate),
      details: payload.data.details,
      status: parseInt(payload.data.status),
      customer_id: payload.data.customer_id,
      customers: payload.data.customer,
      currency_id: payload.data.currency_id,
      date_aux: payload.data.date_aux,
      type_utility_calculation: payload.data.type_utility_calculation,
      supplier_quotations: payload.data.supplier_quotations,
      customer_address_id: payload.data.customer_address_id,
      customer_contact_id: payload.data.customer_contact_id
    }
  },
  SET_MODAL_VISIBLE (state, payload) {
    state.isModalVisible = payload
  },
  SET_MODAL_ACTION_PROP_VISIBLE (state, payload) {
    state.isModalActionPropVisible = payload
  },
  SET_MODAL_PROP_VISIBLE (state, payload) {
    state.isModalPropVisible = payload
  },
  SET_MODAL_LOSS_VISIBLE (state, payload) {
    state.isModalLossVisible = payload
  },
  SET_MODAL_QUOTATIONS_SUPPLIER_VISIBLE (state, payload) {
    state.isModalSupplierQuotationsVisible = payload
  },
  SET_MODAL_PURCHASE_ORDER_VISIBLE (state, payload) {
    state.isModalSetOrderVisible = payload
  },
  SET_FILTER_PARAMS (state, payload) {
    state.filterParams = payload
  },
  SET_CATALOG (state, { object, payload }) {
    state.quotationsCatalog[object] = payload.data
  },
  SET_QUOTATION_PRODUCTS_ATTACHMENTS (state, payload) {
    state.quotationProductsAttachments = payload
  },
  SET_QUOTATION_SUPPLIERS (state, payload) {
    state.quotationSuppliers = payload
  },
  UPDATE_SUPPLIER_QUOTATIONS (state, payload) {
    state.quotation.supplier_quotations = payload
  },
  SET_MODAL_LOSS_REASON_VISIBLE (state, payload) {
    state.isModalLossReasonVisible = payload
  },
  SET_CUSTOMER (state, payload) {
    state.customer = payload
  },
  SET_USERS (state, payload) {
    state.users = payload
  }
}

const actions = {
  initQuotation ({ commit }, payload) {
    commit('INIT_QUOTATION_DETAIL', payload)
  },
  async loadQuotations ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`quotations?page=${payload.page}${state.filterParams}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_QUOTATIONS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadUsers ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`users/all`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_USERS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async addQuotation ({ commit }, payload) {
    const quotation = {
      type_utility: payload.type_utility,
      type_fletes: payload.type_fletes,
      general_delivery_time_flag: payload.general_delivery_time_flag,
      delivery_time: payload.general_delivery_time_flag ? payload.delivery_time : 'individual',
      delivery_address: payload.delivery_address,
      payment_conditions: payload.payment_conditions,
      flete: payload.flete === '' ? 0 : parseFloat(payload.flete),
      discount: payload.discount === '' ? 0 : parseFloat(payload.discount),
      total: parseFloat(payload.total),
      subtotal: parseFloat(payload.subtotal),
      tax_rate: parseInt(16),
      sales_tax: parseFloat(payload.sales_tax),
      utility: payload.utility === '' ? 0 : parseFloat(payload.utility),
      comments: payload.comments,
      exchange_rate: parseFloat(payload.exchange_rate),
      details: payload.details,
      status: parseInt(payload.status),
      customer_id: payload.customer_id,
      currency_id: payload.currency_id,
      email_sent: 0,
      customer_contact_id: payload.customer_contact_id,
      customer_address_id: payload.customer_address_id,
      delivery_unit: payload.delivery_unit,
      type_utility_calculation: payload.type_utility_calculation
    }

    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })

    try {
      const response = await axios.post('quotations', quotation)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_QUOTATION', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.quotations', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
      return e
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async editQuotation ({ commit }, payload) {
    const quotation = {
      folio: payload.folio,
      type_utility: payload.type_utility,
      type_fletes: payload.type_fletes,
      delivery_time: payload.delivery_time,
      general_delivery_time_flag: payload.general_delivery_time_flag,
      delivery_address: payload.delivery_address,
      payment_conditions: payload.payment_conditions,
      flete: payload.flete === '' ? 0 : parseFloat(payload.flete),
      discount: payload.discount === '' ? 0 : parseFloat(payload.discount),
      total: parseFloat(payload.total),
      subtotal: parseFloat(payload.subtotal),
      tax_rate: parseInt(16),
      sales_tax: parseFloat(payload.sales_tax),
      utility: payload.utility === '' ? 0 : parseFloat(payload.utility),
      comments: payload.comments,
      exchange_rate: parseFloat(payload.exchange_rate),
      details: payload.details,
      status: payload.status,
      customer_id: payload.customer_id,
      currency_id: payload.currency_id,
      date_aux: payload.date_aux,
      email_sent: payload.email_sent,
      customer_contact_id: payload.customer_contact_id,
      customer_address_id: payload.customer_address_id,
      delivery_unit: payload.delivery_unit,
      type_utility_calculation: payload.type_utility_calculation
    }

    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })

    try {
      const response = await axios.put(`quotations/${payload.id}`, quotation)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_QUOTATION', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.quotations', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async deleteQuotation ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.delete(`quotations/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_QUOTATION', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.quotations', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async deleteQuotations ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.delete(`quotations/delete`, { params: { ids: payload.ids } })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_QUOTATIONS', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.quotations', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async addQuotationDetail ({ commit, state }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    const QuotationDetail = {
      quantity: parseFloat(payload.quantity),
      unit_price: parseFloat(payload.unit_price),
      unit_price_raw: parseFloat(payload.unit_price_raw),
      unit_price_mxn: parseFloat(payload.unit_price) * parseFloat(state.quotationsCatalog.currencies.find(e => e.id === payload.product.currency_id).exchange_rate).toFixed(5),
      product: payload.product,
      product_id: payload.product.id,
      utility: 0,
      edit: payload.edit,
      supplier: payload.supplier,
      supplier_id: payload.supplier.id,
      individual_delivery_time: payload.individual_delivery_time,
      price: 0,
      pu: 0
    }
    commit('ADD_QUOTATION_DETAIL', QuotationDetail)
    // commit('SET_MODAL_VISIBLE', false)
    app.$Progress.finish()
    commit('SET_LOADING', false, { root: true })
  },
  async editQuotationDetail ({ commit, state }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    const QuotationDetail = {
      quantity: parseFloat(payload.detail.quantity),
      unit_price: parseFloat(payload.detail.unit_price),
      unit_price_raw: parseFloat(payload.detail.unit_price_raw),
      unit_price_mxn: parseFloat(payload.detail.unit_price) * parseFloat(state.quotationsCatalog.currencies.find(e => e.id === payload.detail.product.currency_id).exchange_rate).toFixed(5),
      product: payload.detail.product,
      product_id: payload.detail.product.id,
      utility: payload.detail.utility,
      edit: payload.detail.edit,
      supplier: payload.detail.supplier,
      supplier_id: payload.detail.supplier.id,
      individual_delivery_time: payload.individual_delivery_time,
      price: 0,
      pu: 0
    }
    commit('UPDATE_QUOTATION_DETAIL', { payload: QuotationDetail, idx: payload.index })
    commit('SET_MODAL_VISIBLE', false)
    app.$Progress.finish()
    commit('SET_LOADING', false, { root: true })
  },
  async deleteQuotationDetail ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    commit('DELETE_QUOTATION_DETAIL', payload.index)
    app.$Progress.finish()
    commit('SET_LOADING', false, { root: true })
  },
  async deleteQuotationDetails ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    commit('DELETE_QUOTATION_DETAILS', payload)
    app.$Progress.finish()
    commit('SET_LOADING', false, { root: true })
  },
  async loadQuotation ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`quotations/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_QUOTATION', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async actionQuotation ({ commit }, payload) {
    let props = ''
    payload.props && (props = payload.props)
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.put(`quotations/${payload.id}/${payload.action}${props}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_QUOTATION', response.data)
        commit('UPDATE_QUOTATIONS_ACTION', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.quotations', text: `quotations.${payload.action}`, icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_MODAL_ACTION_PROP_VISIBLE', false)
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  printReport ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      window.open(axios.defaults.baseURL + '/quotations/export?order_by=currency_id,asc' + state.filterParams)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  printReportRecord ({ commit }, payload) {
    let props = ''
    payload.props && (props = `attention=${payload.props}`)
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      window.open(`${axios.defaults.baseURL}/quotations/${payload.id}/export?${props}&lang=${payload.lang}`)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_MODAL_PROP_VISIBLE', false)
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  applyFilter ({ commit }, payload) {
    const filter = parserFilters(payload)
    commit('SET_FILTER_PARAMS', filter)
  },
  clearFilter ({ commit }, payload) {
    const filter = ''
    commit('SET_FILTER_PARAMS', filter)
  },
  async loadCatalog ({ commit }, payload) {
    let url = parserSlug(payload.url)
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`${url}${payload.filter}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CATALOG', { object: payload.url, payload: response.data })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async lossQuotation ({ commit }, payload) {
    const quotation = {
      loss_reason_id: payload.form.loss_reason_id,
      loss_description: payload.form.loss_description
    }
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.put(`quotations/${payload.id}/loss`, quotation)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_QUOTATION', response.data)
        commit('UPDATE_QUOTATIONS_ACTION', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.quotations', text: `quotations.${payload.action}`, icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_MODAL_LOSS_VISIBLE', false)
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async setOrderQuotation ({ commit }, payload) {
    let formData = new FormData()
    formData.append('order_customer', payload.form.order_customer)
    formData.append('purchase_order_file', payload.purchase_order_file)
    formData.append('_method', 'put')

    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })

    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`quotations/${payload.id}/set-order`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_QUOTATION', response.data)
        commit('UPDATE_QUOTATIONS_ACTION', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.quotations', text: 'quotations.set-order', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_MODAL_PURCHASE_ORDER_VISIBLE', false)
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadQuotationProductsAttachments ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })

    try {
      const response = await axios.get(`quotations/${payload}/products-attachments`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_QUOTATION_PRODUCTS_ATTACHMENTS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadQuotationSuppliers ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`quotations/${payload}/suppliers`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_QUOTATION_SUPPLIERS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async addSupplierQuotation ({ commit }, payload) {
    let formData = new FormData()
    formData.append('supplier_id', payload.form.supplier_id)
    formData.append('file', payload.file)

    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })

    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`quotations/${payload.quotation_id}/suppliers`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_SUPPLIER_QUOTATIONS', response.data.supplier_quotations)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.quotations', text: 'quotations.set-order', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  loadCatalogAux ({ commit }, payload) {
    commit('SET_CATALOG', { object: payload.url, payload: payload })
  },
  setModalVisible ({ commit }, payload) {
    commit('SET_MODAL_VISIBLE', payload)
  },
  setModalActionPropVisible ({ commit }, payload) {
    commit('SET_MODAL_ACTION_PROP_VISIBLE', payload)
  },
  setModalPropVisible ({ commit }, payload) {
    commit('SET_MODAL_PROP_VISIBLE', payload)
  },
  setModalLossVisible ({ commit }, payload) {
    commit('SET_MODAL_LOSS_VISIBLE', payload)
  },
  setModalImportVisible ({ commit }, payload) {
    commit('SET_MODAL_IMPORT_VISIBLE', payload, { root: true })
  },
  setModalSendEmail ({ commit }, payload) {
    commit('SET_MODAL_SEND_EMAIL', payload, { root: true })
  },
  setModalPurchaseOrderVisible ({ commit }, payload) {
    commit('SET_MODAL_PURCHASE_ORDER_VISIBLE', payload)
  },
  setModalQuotationsSupplierVisible ({ commit }, payload) {
    commit('SET_MODAL_QUOTATIONS_SUPPLIER_VISIBLE', payload)
  },
  async download ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      window.open(`${Vue.axios.defaults.baseURL}/attachments/${payload.id}/download`)
    } catch (error) {
      app.$Progress.fail()
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  setModalLossReasonVisible ({ commit }, payload) {
    commit('SET_MODAL_LOSS_REASON_VISIBLE', payload)
  },
  async getCustomer ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`customers/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CUSTOMER', response.data.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  }
}

const getters = {
  quotation: state => state.quotation,
  quotations: state => state.quotations,
  quotationsCatalog: state => state.quotationsCatalog,
  pagination: state => state.pagination,
  isModalVisible: state => state.isModalVisible,
  isModalPropVisible: state => state.isModalPropVisible,
  isModalLossVisible: state => state.isModalLossVisible,
  isModalActionPropVisible: state => state.isModalActionPropVisible,
  isModalSetOrderVisible: state => state.isModalSetOrderVisible,
  filterParams: state => state.filterParams,
  quotationProductsAttachments: state => state.quotationProductsAttachments,
  isModalSupplierQuotationsVisible: state => state.isModalSupplierQuotationsVisible,
  quotationSuppliers: state => state.quotationSuppliers,
  isModalLossReasonVisible: state => state.isModalLossReasonVisible,
  customer: state => state.customer,
  users: state => state.users
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
